module.exports = __webpack_public_path__ + "img/lake-village-map--en.86538cae.png";